export default __webpack_public_path__ + "img/sagoo/sagoo7_700.jpg";